<script>
import DatePicker from "vue2-datepicker";

import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import { getStrategyListPair, getAliasList, getAliasStrategy, getStrategyClass, stopStrategy1, createStrategy, updateStrategy, deleteStrategy, startStrategy1} from "../../../../api/user";
import Loader from "@/components/widgets/loader";
import Swal from "sweetalert2";

/**
 * Orders component
 */
export default {
    page: {
        title: "策略管理",
        meta: [{
            name: "description",
            content: appConfig.description,
        } ]
    },
    components: {
        DatePicker,
        Layout,
        PageHeader,
    },
    props: {
        updating: {
            type: Boolean,
        },
    },
    data() {
        return {
            pwd: "",
            current_data: {},
            strategy_class_dict: {},
            alias_list: [],
            strategy_name_list: [],
            strategyData: [],
            title: "策略管理",
            items: [{
                    text: "",
                    href: "",
                },
                {
                    text: "",
                    active: true,
                },
            ],
            showSetting: false,
            showModal: false,
            showStopModal: false,
            showDeleteModal: false,
            showCreateModal: false,
            isauthenticated: true,
            count: 0,
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            filter: null,
            filterOn: [],
            sortBy: "value",
            sortDesc: false,
            fields: [{
                    key: "create_time",
                    sortable: true,
                },
                {
                    key: "alias",
                    sortable: true,
                },
                {
                    key: "name",
                    sortable: true,
                },
                {
                    key: "symbol_list",
                    sortable: true,
                },
                {
                    key: "status",
                    sortable: true,
                },
            ],
            aliasValue: "",
            strategyValue: "",
            settingValue: {},
            statusValue: "",
            typeValue: null,
            datepickervalue: "",
            sorted_field: "创建时间",
            sorted_list: [
                "1天交易量",
                "3天交易量",
                "总持仓",
                "收益",
                "盘中损益",
            ],
            sorted_direction: "DESC",
            direction_list: ["ASC", "DESC"]
        };
    },
    computed: {
        /**
         * Total no. of records
         */
        // rows() {
        //     return this.ordersData.length;
        // },
    },
    mounted() {
        // Set the initial number of items
        this.get_strategy_class()
        this.get_alias_list()
        // this.get_strategy_list()
    },
    methods: {
        /**
         * Search the table data with search input
         */
        // onFiltered(filteredItems) {
        //     // Trigger pagination to update the number of buttons/pages due to filtering
        //     this.totalRows = filteredItems.length;
        //     this.currentPage = 1;
        // },
        get_strategy_list() {
        let promise = getStrategyListPair(this.aliasValue, this.sorted_field, this.sorted_direction); return promise.then(res => {
            this.strategyData = res["data"]
            // this.trade_currentPage = res["offset"] + 1
            console.log(this.order_currentPage)
            return res["data"]
        }).catch(error => {
            console.log(error)
        })
        },
        checkCurrentSetting(current_data) {
            this.current_data = current_data
            this.showSetting = true
        },
        checkCreateSetting() {
            this.showModal = true
        },
        showCreate() {
            this.showCreateModal = true
        },
        showStopSetting(current_data) {
            this.current_data = current_data
            this.showStopModal = true
        },
        showDeleteSetting(current_data) {
            this.current_data = current_data
            this.showDeleteModal = true
        },
        updateSetting(strategy_id, setting, pwd){
            let data = {
                "strategy_id": strategy_id,
                "passwd": pwd,
                "setting": setting
            }
            let promise = updateStrategy(data); return promise.then(res => {
                if (res["message"] == "请求成功"){
                    this.pwd = ""
                    Swal.fire({
                    title: "配置更新成功！",
                    text: res["message"],
                    icon: "success",
                    // background: "#222736"
                    })
                    window.location.reload()
                } else{
                    Swal.fire({
                    title: "配置更新失败！",
                    text: res["message"],
                    icon: "error",
                    // background: "#222736"
                    })
                    this.showSetting = false
                    }
            }).catch(error => {
                console.log(error)
            })
        },
        get_alias_list() {
        let promise = getAliasList(); return promise.then(res => {
            res = ["test", "zenxpair", "king", "pair03", "martin_u2"]
            this.alias_list = res
            console.log(this.alias_list)
        }).catch(error => {
            console.log(error)
        })
        },
        get_strategy_class() {
        let promise = getStrategyClass(); return promise.then(res => {
            res = ["TestPairTrading"]
            this.strategy_name_list = res
        }).catch(error => {
            console.log(error)
        })
        },
        get_alias_strategy(alias) {
        let promise = getAliasStrategy(alias); return promise.then(res => {
            this.strategy_name_list = res
            return res
        }).catch(error => {
            console.log(error)
        })
        },
        chooseAlias(){
            this.strategyValue = ""
            this.settingValue = {}
            this.get_strategy_list()
        },
        chooseStrategy(){
            let promise = getAliasStrategy(this.aliasValue, this.strategyValue); return promise.then(res => {
                this.settingValue = res
                console.log(this.settingValue)
            }).catch(error => {
                console.log(error)
        })
        },
        stop_Stratagy(strategy, pwd){
            let data = {
                "strategy_id": strategy.id,
                "passwd": pwd
            }
            if (strategy.operate == "停止") {
                let promise = stopStrategy1(data); return promise.then(res => {
                if (res["message"] == "请求成功"){
                    this.pwd = ""
                    Swal.fire({
                    title: "策略停止成功！",
                    text: res["message"],
                    icon: "success",
                    // background: "#222736"
                    })
                    window.location.reload()
                } else{
                    Swal.fire({
                    title: "策略停止失败！",
                    text: res["message"],
                    icon: "error",
                    // background: "#222736"
                    })
                    this.showStopModal = false
                    }
            }).catch(error => {
                console.log(error)
            })
            }
            if (strategy.operate == "启动") {
                let promise = startStrategy1(data); return promise.then(res => {
                if (res["message"] == "请求成功"){
                    this.pwd = ""
                    Swal.fire({
                    title: "策略启动成功！",
                    text: res["message"],
                    icon: "success",
                    // background: "#222736"
                    })
                    window.location.reload()
                } else{
                    Swal.fire({
                    title: "策略启动失败！",
                    text: res["message"],
                    icon: "error",
                    // background: "#222736"
                    })
                    this.showStopModal = false
                    }
            }).catch(error => {
                console.log(error)
            })
            }
        },
        delete_Stratagy(strategy_id, pwd){
            let data = {
                "strategy_id": strategy_id,
                "passwd": pwd
            }
            let promise = deleteStrategy(data); return promise.then(res => {
                if (res["message"] == "请求成功"){
                    this.pwd = ""
                    Swal.fire({
                    title: "策略删除成功！",
                    text: res["message"],
                    icon: "success",
                    // background: "#222736"
                    })
                    window.location.reload()
                } else{
                    Swal.fire({
                    title: "策略删除失败！",
                    text: res["message"],
                    icon: "error",
                    // background: "#222736"
                    })
                    this.showDeleteModal = false
                    }
            }).catch(error => {
                console.log(error)
            })
        },
        create_Stratagy(pwd){
            let set = this.settingValue
            set["alias"] = this.aliasValue
            let data = {
                "setting": set,
                "passwd": pwd
            }
            let promise = createStrategy(data); return promise.then(res => {
                if (res["message"] == "请求成功"){
                    this.pwd = ""
                    Swal.fire({
                    title: "策略创建成功！",
                    text: res["message"],
                    icon: "success",
                    // background: "#009933"
                    })
                    window.location.reload()
                } else{
                    Swal.fire({
                    title: "策略创建失败！",
                    text: res["message"],
                    icon: "error",
                    // background: "#cc6633"
                    })
                    this.showCreateModal = false
                    }
                
            }).catch(error => {
                console.log(error)
            })
        }

    },
};
</script>

<template lang="en">
<Layout>
    <PageHeader :title="title"/>

    <form>
        <div class="row">
            <div class="col-xl col-sm-6">
                <div class="form-group mt-3 mb-0">
                    <label>Alias :</label>
                    <b-form-select v-model="aliasValue" :options="alias_list" @change="chooseAlias"></b-form-select>
                </div>
            </div>

            <div class="col-xl col-sm-6">
                <div class="form-group mt-3 mb-0">
                    <label>Strategy</label>
                    <b-form-select v-model="strategyValue" :options="strategy_name_list" @change="chooseStrategy"></b-form-select>
                </div>
            </div>

            <div class="col-xl col-sm-6">
                <div class="form-group mt-3 mb-0">
                    <label>setting</label>
                    <td>
                            <!-- Button trigger modal -->
                            <button
                              type="button"
                              class="btn btn-success btn-sm btn-rounded"
                              @click="checkCreateSetting"
                            >
                              查看配置
                            </button>

                            <b-modal
                              v-model="showModal"
                              title="策略参数配置"
                              centered
                            >
                              <div>
                                <table class="table table-centered table-nowrap">
                                  <!-- <b-form-group
                                    id="example text"
                                    label-cols-lg="5"
                                    label="品种"
                                    label-for="text"
                                  >
                                  <b-form-input v-model="current_strat_symbol" />
                                  </b-form-group> -->
                                  <div v-for="(value,key,index) in settingValue" :key="index">
                                    <b-form-group
                                      id="example text"
                                      label-cols-lg="5"
                                      :label="key"
                                      label-for="text"
                                    >
                                    <b-form-input v-model="settingValue[key]"/>
                                    </b-form-group>
                                  </div>
                                  <!-- <b-form-group
                                    id="example text"
                                    label-cols-lg="5"
                                    label="密码"
                                    label-for="text"
                                  >
                                  <b-form-input type="password" v-model='pwd'/>
                                  </b-form-group> -->
                                </table>
                              </div>
                              <template v-slot:modal-footer>
                                <!-- <b-button
                                  variant="secondary"
                                  @click="runStrategy(current_strat, pwd, current_strat_symbol, current_strat_seting, current_strat_index)"
                                >
                                  确认
                                </b-button> -->
                              </template>
                            </b-modal>
                          </td>
                </div>
            </div>

            <!-- <div class="col-xl col-sm-6">
                <div class="form-group mt-3 mb-0">
                    <label>Status</label>
                    <b-form-select v-model="statusValue" :options="['Completed', 'Pending']"></b-form-select>
                </div>
            </div> -->

            <div class="col-xl col-sm-6 align-self-end">
                <div class="mt-3">
                    <button type="button" 
                    class="btn btn-primary w-md"
                    @click="showCreate()">
                        新建策略
                    </button>
                    <b-modal
                    v-model="showCreateModal"
                    title="请输入密码"
                    centered
                    >
                    <div>
                        <table class="table table-centered table-nowrap">
                        <b-form-group
                            id="example text"
                            label-cols-lg="4"
                            label="密码"
                            label-for="text"
                        >
                        <b-form-input type="password" v-model='pwd'/>
                        </b-form-group>
                        </table>
                    </div>
                    <template v-slot:modal-footer>
                        <b-button
                        variant="secondary"
                        @click="create_Stratagy(pwd)"
                        >
                        确认
                        </b-button>
                    </template>
                    </b-modal>
                </div>
            </div>

            <div class="col-xl col-sm-6">
                <div class="form-group mt-3 mb-0">
                    <label>Sorted_by</label>
                    <b-form-select v-model="sorted_field" :options="sorted_list" @change="get_strategy_list"></b-form-select>
                </div>
            </div>

            <div class="col-xl col-sm-6">
                <div class="form-group mt-3 mb-0">
                    <label>Direction</label>
                    <b-form-select v-model="sorted_direction" :options="direction_list" @change="get_strategy_list"></b-form-select>
                </div>
            </div>
        </div>

        <div v="strategyData">
            <div v-if="isauthenticated">
                <div class="row">
                <div class="col-12">
                    <div class="card">
                    <div class="card-body">
                        <!-- Table data -->
                        <!-- <T :transactions="strategy_list" /> -->
                        <Loader :loading="updating">
                        <div class="table-responsive mb-0">
                            <table class="table table-centered table-nowrap">
                            <thead class="thead-light">
                                <tr>
                                <th>Name</th>
                                <!-- <th>type</th> -->
                                <!-- <th>策略设置</th> -->
                                <th>Alias</th>
                                <th>创建时间</th>
                                <th>持仓</th>
                                <th>总持仓</th>
				<th>交易量(1天)</th>
				<th>交易量(3天)</th>
                                <th>收益</th>
                                <th>盘中损益</th>
                                <th>zscore</th>
                                <th>慢窗</th>
                                <th>快窗</th>
                                <th>K线级别</th>
                                <th>开仓阈值</th>
                                <th>关仓阈值</th>
                                <th>状态</th>
                                <th>操作</th>
                                <th>配置</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                v-for="data in strategyData"
                                :key="data.id"
                                >
                                <td>
                                    <a
                                    href="javascript: void(0);"
                                    class="text-body font-weight-bold"
                                    >{{ data.name }}</a>
                                </td>
                                <td>
                                    <a
                                    href="javascript: void(0);"
                                    class="text-body font-weight-bold"
                                    >{{ data.alias }}</a>
                                </td>
                                <td>{{ data.create_time }}</td>
                                <td>{{ data.position }}</td>
                                <td>{{ data.position_value }}</td>
				<td>{{ data.volume1 }}</td>
				<td>{{ data.volume3 }}</td>
                                <td>{{ data.pnl }}</td>
                                <td>{{ data.unrealized_pnl }}</td>
                                <td>{{ data.zscore }}</td>
                                <td>{{ data.long_window }}</td>
                                <td>{{ data.short_window }}</td>
                                <td>{{ data.kline_size }}</td>
                                <td>{{ data.entry_cutoff }}</td>
                                <td>{{ data.exit_cutoff }}</td>
                                <!-- <td>{{ job.count }}</td> -->
                                <td>
                                    <span
                                    class="badge badge-pill badge-soft-success font-size-12"
                                    :class="{
                                        'badge-soft-danger': `${data.status}` === '停止',
                                        // 'badge-soft-warning': `${data.status}` === 'normal',
                                    }"
                                    >{{ data.status }}</span>
                                </td>
                                <td>
                                    <button 
                                    type="button"
                                    class="btn btn-sm btn-rounded"
                                    :class="{
                                        'btn-danger': `${data.status}` === '运行',
                                        'btn-success': `${data.status}` === '停止',
                                    }"
                                    @click="showStopSetting(data)"
                                    >
                                    {{ data.operate }}
                                    </button>
                                    <b-modal
                                    v-model="showStopModal"
                                    title="请输入密码"
                                    centered
                                    >
                                    <div>
                                        <table class="table table-centered table-nowrap">
                                        <b-form-group
                                            id="example text"
                                            label-cols-lg="4"
                                            label="密码"
                                            label-for="text"
                                        >
                                        <b-form-input type="password" v-model='pwd'/>
                                        </b-form-group>
                                        </table>
                                    </div>
                                    <template v-slot:modal-footer>
                                        <b-button
                                        variant="secondary"
                                        @click="stop_Stratagy(current_data, pwd)"
                                        >
                                        确认
                                        </b-button>
                                    </template>
                                    </b-modal>
                                </td>
                                <td>
                                    <button  


                                    type="button"
                                    class="btn btn-info btn-sm btn-rounded"
                                    @click="checkCurrentSetting(data)"
                                    >
                                    配置
                                    </button>

                                    <b-modal
                                    v-model="showSetting"
                                    title="修改策略参数配置"
                                    centered
                                    >
                                    <div>
                                        <table class="table table-centered table-nowrap">
                                        <!-- <b-form-group
                                            id="example text"
                                            label-cols-lg="5"
                                            label="品种"
                                            label-for="text"
                                        >
                                        <b-form-input v-model="current_strat_symbol" />
                                        </b-form-group> -->
                                        <div v-for="(value,key,index) in current_data.setting" :key="index">
                                            <b-form-group
                                            id="example text"
                                            label-cols-lg="5"
                                            :label="key"
                                            label-for="text"
                                            >
                                            <b-form-input v-model="current_data.setting[key]"/>
                                            </b-form-group>
                                        </div>
                                        <b-form-group
                                            id="example text"
                                            label-cols-lg="5"
                                            label="密码"
                                            label-for="text"
                                        >
                                        <b-form-input type="password" v-model='pwd'/>
                                        </b-form-group>
                                        </table>
                                    </div>
                                    <template v-slot:modal-footer>
                                        <b-button
                                        variant="secondary"
                                        @click="updateSetting(current_data.id, current_data.setting, pwd)"
                                        >
                                        确认更新
                                        </b-button>
                                    </template>
                                    </b-modal>
                                </td>
                                <td>
                                    <button  v-if="data.status=='停止'"
                                    type="button"
                                    class="btn btn-danger btn-sm btn-rounded"
                                    @click="showDeleteSetting(data)"
                                    >
                                    删除
                                    </button>
                                    <b-modal
                                    v-model="showDeleteModal"
                                    title="请输入密码"
                                    centered
                                    >
                                    <div>
                                        <table class="table table-centered table-nowrap">
                                        <b-form-group
                                            id="example text"
                                            label-cols-lg="4"
                                            label="密码"
                                            label-for="text"
                                        >
                                        <b-form-input type="password" v-model='pwd'/>
                                        </b-form-group>
                                        </table>
                                    </div>
                                    <template v-slot:modal-footer>
                                        <b-button
                                        variant="secondary"
                                        @click="delete_Stratagy(current_data.id, pwd)"
                                        >
                                        确认
                                        </b-button>
                                    </template>
                                    </b-modal>
                                </td>
                                </tr>
                            </tbody>
                            </table>
                        </div>
                        <!-- end table -->
                        </Loader>
                    </div>
                    <!-- end card-body -->
                    </div>
                    <!-- end card -->
                </div>
                <!-- end col -->
                </div>
            </div>
        </div>
    </form>

    

</Layout>
</template>
